// extracted by mini-css-extract-plugin
export var checkbox = "_6c-0";
export var circle = "_6c-3";
export var horizontalContainer = "_6c-7";
export var sm = "_6c-5";
export var switch0 = "_6c-2";
export var switchDisabled = "_6c-8";
export var switchEnabled = "_6c-1";
export var textSwitchContainer = "_6c-9";
export var textSwitchOption = "_6c-a";
export var textSwitchOptionSelected = "_6c-b";
export var verticalContainer = "_6c-6";
export var xs = "_6c-4";